import React from 'react';
import { Link } from 'react-router-dom';
import './CategoryCard.css';

const CategoryCard = ({ category, showDescription = true, showSubCategories = false, onCategorySelect = null }) => {
  const handleCategoryClick = (e) => {
    // If onCategorySelect is provided, call it and prevent default navigation
    if (onCategorySelect) {
      e.preventDefault();
      e.stopPropagation();
      onCategorySelect(category);
    } else {
      // You can add analytics or other tracking here
      console.log('Category clicked:', category.name);
    }
  };

  return (
    <div className="category-card" onClick={handleCategoryClick}>
      <Link to={`/categories/${category.slug}`} className="category-link" onClick={handleCategoryClick}>
        <div className="category-card-content">
          {/* Category Icon */}
          <div className="category-icon">
            {category.icon ? (
              <i className={`${category.icon} category-icon-svg`}></i>
            ) : (
              <i className="bi bi-tag category-icon-svg"></i>
            )}
          </div>

          {/* Category Image (if available) */}
          {category.image_url && (
            <div className="category-image">
              <img src={category.image_url} alt={category.name} />
            </div>
          )}

          {/* Category Info */}
          <div className="category-info">
            <h3 className="category-name">{category.name}</h3>
            
            {showDescription && category.description && (
              <p className="category-description">{category.description}</p>
            )}

            {/* Category Level Badge */}
            <div className="category-badges">
              {category.level === 0 && (
                <span className="badge badge-primary">Main Category</span>
              )}
              {category.level === 1 && (
                <span className="badge badge-secondary">Sub Category</span>
              )}
              {category.level === 2 && (
                <span className="badge badge-tertiary">Sub-Sub Category</span>
              )}
              {category.is_featured && (
                <span className="badge badge-featured">Featured</span>
              )}
            </div>

            {/* Sub-categories count */}
            {showSubCategories && category.children && category.children.length > 0 && (
              <div className="sub-categories-count">
                <i className="bi bi-arrow-right-circle"></i>
                <span>{category.children.length} sub-categories</span>
              </div>
            )}

            {/* Parent category info */}
            {category.parent && (
              <div className="parent-category">
                <small>Under: {category.parent.name}</small>
              </div>
            )}
          </div>

          {/* Arrow indicator */}
          <div className="category-arrow">
            <i className="bi bi-arrow-right"></i>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CategoryCard;
